module.exports = __webpack_public_path__ + "img/linda.e489bb8d.png";